import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[nrSingleselectAieaProp]',
  standalone: true,
})
export class NrSingleselectAieaPropDirective implements AfterViewInit {
  @Input() ariaRequired!: boolean;

  constructor(private _el: ElementRef) {}

  ngAfterViewInit() {
    const inputElement = this._el.nativeElement.querySelector('div > span[role="combobox"]');
    inputElement?.setAttribute('aria-expanded', false);
    inputElement?.setAttribute('aria-required', this.ariaRequired);
  }
}
